module.exports = __webpack_public_path__ + "img/work-from-home-dark.bd3171e2.svg";